<template>
    <div class="">
        <!-- <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end" @click="modalClose(false)">
                    <ion-icon :icon= "closeCircleOutline" class="closeIcon"></ion-icon>
                </ion-buttons>
                <ion-title class="ion-text-center">{{ holidayType }}</ion-title>
            </ion-toolbar>
        </ion-header> -->
        <ion-content class="ion-padding ion-margin-top stop-repeating-content">
            <ion-grid>
                <ion-row class="ion-text-right">
                    <ion-col>
                        <p>{{ holidayType }}</p>
                    </ion-col>
                    <ion-col class="ion-text-right">
                            <!-- <ion-buttons slot="end" @click="modalClose(false)"> -->
                                <ion-icon :icon= "closeCircleOutline"  @click="saveHoliday(false)" class="closeIcon"></ion-icon>
                            <!-- </ion-buttons> -->
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col col-size="2"></ion-col>
                    <ion-col size="8" size-md="8" class="col-padding">
                        <div class="border-line-34 readonly margin-top-10">
                            <ion-input
                                type="text"
                                @input="holidayName = $event.target.value"
                                :value="holidayName"
                                readonly="false"
                                placeholder="Enter Holiday Name"
                                v-bind:disabled="disableNameAndDate"
                            ></ion-input>
                        </div>
                    </ion-col>
                    <ion-col col-size="2"></ion-col>
                </ion-row>
                <ion-row>
                    <ion-col col-size="2"></ion-col>
                    <ion-col size="8" size-md="8" class="col-padding">
                        <div class="date-picker-box margin-top-10 datepicker-web">
                        <!-- <datepicker
                            class="form-vue-picker"
                            placeholder="DD/MON/YYYY"
                            format="dd/MMM/yyyy"
                            v-model="selectedDate"
                            typeable="true"
                            v-bind:disabled="disableNameAndDate"
                        ></datepicker> -->
                        <VueDatePicker v-model="selectedDate" v-bind:disabled="disableNameAndDate" @update:model-value="selectedDate" :enable-time-picker="false" placeholder="DD/MON/YYYY"/>
                        <span class="custom-calendar-icon">
                            <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                        </div>
                    </ion-col>
                    <ion-col col-size="2"></ion-col>
                </ion-row>
                <br />
                <ion-row>
                    <ion-col class="ion-text-center">
                        <ion-checkbox v-bind="fulldaySelected" v-bind:checked="fulldaySelected" @ionChange="onchangeFull(fulldaySelected)"></ion-checkbox>
                        <span> Full Day Holiday</span>
                    </ion-col>
                </ion-row>
                <br />
                <ion-row class="ion-text-center" v-bind:disabled="fulldaySelected">
                    <ion-col col-size="2"></ion-col>
                    <ion-col col-size="4" class="ion-text-left">
                        <div class="date-picker-box-time margin-top-10 datepicker-web">
                            <!-- <ion-datetime
                                placeholder="Start Time"
                                @ionChange="selectedTime.startTime = $event.target.value"
                                display-format="HH:mm"
                                picker-format="HH:mm"
                                v-bind:value="selectedTime.startTime"
                                v-bind:disabled="fulldaySelected"
                            ></ion-datetime> -->
                            <VueDatePicker v-model="holidayStartTime" v-bind:disabled="fulldaySelected" @update:model-value="holidayStartTime" time-picker placeholder="Start Time" />
                            <span class="custom-calendar-icon">
                                <img src="/assets/images/time_capacity/114264.png" />
                            </span>
                        </div>
                    </ion-col>
                    <ion-col col-size="4" class="ion-text-left">
                        <div class="date-picker-box-time margin-top-10 datepicker-web">
                            <!-- <ion-datetime
                                placeholder="End Time"
                                @ionChange="selectedTime.endTime = $event.target.value"
                                display-format="HH:mm"
                                picker-format="HH:mm"
                                v-bind:value="selectedTime.endTime"
                                v-bind:disabled="fulldaySelected"
                            ></ion-datetime> -->
                            <VueDatePicker 
                            v-model="holidayEndTime" 
                            time-picker 
                            v-bind:disabled="fulldaySelected"
                            @update:model-value="holidayEndTime"
                            placeholder="End Time" />
                            <span class="custom-calendar-icon">
                                <img src="/assets/images/time_capacity/114264.png" />
                            </span>
                        </div>
                    </ion-col>
                    <ion-col col-size="2"></ion-col>
                </ion-row>
                <br />
                <ion-row class="ion-text-center">
                    <ion-col col-size="12">
                        <!-- <ion-button class="btn-primary" @click="modalClose(true)" v-bind:disabled=disableButton>Save</ion-button> -->
                        <ion-button class="btn-primary" @click="saveHoliday(true)" v-bind:disabled=disableButton>Save</ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <div class="spinner">
                <ion-spinner v-if="loaderTab"></ion-spinner>
            </div>
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
import VueDatePicker from '@vuepic/vue-datepicker';
import { ToastUtils } from "../../util/toast-utils";
import { closeCircleOutline } from 'ionicons/icons';
import { HolidayService } from "../../service/holiday/holiday.service";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";
import moment from 'moment'
import { fastforward } from 'ionicons/icons';
import { IonButton, IonButtons, IonCheckbox, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInput, IonRow, IonSpinner, IonTitle, IonToolbar, modalController } from "@ionic/vue";

export default defineComponent ({
    name: 'HolidayEditAdd',
    components: {
        VueDatePicker, IonHeader, IonToolbar, IonButtons, IonIcon, IonTitle, IonContent, IonGrid, IonRow, IonCol, IonInput, IonCheckbox, IonButton, IonSpinner, modalController
    },
    // props: ["selectedHolidayData", 'holidayType', 'stationId', 'stationName', 'state', 'startTime', 'endTime'],
    props: {
        selectedHolidayData : {type: Object},
        holidayType : {type: String , default : "Holiday"},
        stationId : {type: Number},
        stationName: {type: String},
        state : {type: String},
        startTime : {type: String},
        endTime : {type: String},
        fullDayInd: {type: String}
    },
    data() {
        return {
            closeCircleOutline,
            loaderTab: false,
            disableButton: false,
            form: {},
            selectedDate: new Date(),
            selectedTime: {},
            fulldaySelected: false,
            holidayName:'',
            disableNameAndDate: false,
            holidayStartTime: null,
            holidayEndTime: null,
            st: ""

        }
    },
    async mounted() {
        this.holidayName = this.selectedHolidayData.holidayName != null ? this.selectedHolidayData.holidayName : "";
        this.disableNameAndDate = this.selectedHolidayData.holidayName != null ? true : false;
        this.selectedDate = this.selectedHolidayData.date != undefined ? this.selectedHolidayData.date : new Date();
        if(this.fullDayInd == 'Y') {
            this.fulldaySelected = true;
        } else {
            this.fulldaySelected = false;
        }
        if(this.startTime != null) {
            let st = this.startTime.split(":");
            this.holidayStartTime = {
                "hours" : st[0],
                "minutes" : st[1]
            }
        }
        if(this.endTime != null) {
            let st = this.endTime.split(":");
            this.holidayEndTime = {
                "hours" : st[0],
                "minutes" : st[1]
            }
        }
        
        // this.selectedTime.startTime = this.selectedHolidayData.startTime != '00:00:00' ? {hours: new Date(this.selectedHolidayData.startTime)} : '';
        // this.selectedTime.endTime = this.selectedHolidayData.endTime != '00:00:00' ?  this.selectedHolidayData.endTime : '';
        // if(this.holidayName != undefined && this.selectedDate) {
        // this.disableNameAndDate = true;
        // } else {
        // this.disableNameAndDate = false;
        // }
        // if(
        // (this.selectedTime.startTime === undefined || 
        // this.selectedTime.endTime === undefined || this.selectedTime.startTime === '' || this.selectedTime.endTime === '') && this.holidayType == 'Edit Holiday'
        // ) {
        //     this.fulldaySelected = true;
        // }
    },
    methods: {
        async modalClose (saveFormData) {
            let formResponse = {
                stationId: this.stationId,
                holidayId: this.selectedHolidayData.holidayId,
                stationHolidayId: this.selectedHolidayData.stationHolidayId,
                year: moment(this.selectedDate).format('YYYY'),
                state: this.state,
                holidayName: this.holidayName,
                date: moment(this.selectedDate).format('YYYY/MM/DD'),
                fulldayHoliday: (this.selectedTime.startTime == '' && this.selectedTime.endTime == ''|| this.selectedTime.startTime == '00:00:00' && this.selectedTime.endTime == '00:00:00') ? 'Y' : 'N',
                startTime: (this.selectedTime.startTime != '' && this.selectedTime.startTime != '00:00:00' && new Date(this.selectedTime.startTime).getDate()) ? moment(this.selectedTime.startTime).format('HH:mm:ss') : this.selectedTime.startTime,
                endTime: (this.selectedTime.endTime != '' && this.selectedTime.endTime != '00:00:00' && new Date(this.selectedTime.endTime).getDate()) ? moment(this.selectedTime.endTime).format('HH:mm:ss') : this.selectedTime.endTime,
                status: this.selectedHolidayData.status != undefined ? this.selectedHolidayData.status : 'A',
                success: saveFormData,
                formData: saveFormData ? this.selectedTime : null,
                fromWhere: this.holidayType,
            };
            let addHoliday;
            if(saveFormData == true) {
                if(this.holidayName === undefined || this.holidayName === '') {
                    new ToastUtils().presentToast("Enter Holiday Name");
                } else if(this.selectedDate === undefined || new Date(this.selectedDate) <= new Date()) {
                    new ToastUtils().presentToast("Select valid date");
                } else if(this.fulldaySelected == false) {
                    if(
                        this.selectedTime.startTime === undefined || 
                        this.selectedTime.endTime === undefined || 
                        this.selectedTime.startTime >= this.selectedTime.endTime) {
                                new ToastUtils().presentToast("Select valid time");
                    } else {
                        this.loaderTab = true;
                        this.disableButton = true;
                        let checkReservation = await new HolidayService().checkReservationForSelectedDate({
                        "stationId" : this.stationId,
                        "startDateTime": moment(this.selectedDate).format('DD/MM/YYYY'),
                        "startTime": (this.selectedTime.startTime != '' && this.selectedTime.startTime != '00:00:00' && new Date(this.selectedTime.startTime).getDate()) ? moment(this.selectedTime.startTime).format('HH:mm') : this.selectedTime.startTime,
                        "endTime": (this.selectedTime.endTime != '' && this.selectedTime.endTime != '00:00:00' && new Date(this.selectedTime.endTime).getDate()) ? moment(this.selectedTime.endTime).format('HH:mm') : this.selectedTime.endTime,
                    
                        });
                        if(checkReservation == 'true') {
                        addHoliday = await new HolidayService().addHolidayInStationWorkHoliday(formResponse);
                        // await this.$ionic.modalController.dismiss(addHoliday);
                        await modalController.dismiss(addHoliday);
                        this.loaderTab = false;
                        this.disableButton = false;
                        } else {
                        this.loaderTab = false;
                        this.disableButton = false;
                        new ToastUtils().presentToast("You can't take leave for this day");
                        }
                    }
                    
                } else {
                    this.loaderTab = true;
                    this.disableButton = true;
                    let checkReservation = await new HolidayService().checkReservationForSelectedDate({
                        "stationId" : this.stationId,
                        "startDateTime": moment(this.selectedDate).format('DD/MM/YYYY'),
                        "startTime": (this.selectedTime.startTime != '' && this.selectedTime.startTime != '00:00:00' && new Date(this.selectedTime.startTime).getDate()) ? moment(this.selectedTime.startTime).format('HH:mm') : this.selectedTime.startTime,
                        "endTime": (this.selectedTime.endTime != '' && this.selectedTime.endTime != '00:00:00' && new Date(this.selectedTime.endTime).getDate()) ? moment(this.selectedTime.endTime).format('HH:mm') : this.selectedTime.endTime,
                    });
                    if(checkReservation == 'true') {
                        addHoliday = await new HolidayService().addHolidayInStationWorkHoliday(formResponse);
                        // await this.$ionic.modalController.dismiss(addHoliday);
                        await modalController.dismiss(addHoliday);
                        this.loaderTab = false;
                        this.disableButton = false;
                    } else {
                        this.loaderTab = false;
                        this.disableButton = false;
                        new ToastUtils().presentToast("You can't take leave for this day");
                    } 
                }
            } else {
                // this.$ionic.modalController.dismiss('');
                modalController.dismiss('');

            }
        },
        selectFullDay() {
            // console.log(this.fulldaySelected);
        },
        onchangeFull(val) {
            if(val) {
            this.fulldaySelected = false;
                this.selectedTime.startTime = this.startTime;
                this.selectedTime.endTime = this.endTime;
            } else {
                this.fulldaySelected = true;
                this.selectedTime.startTime = (this.selectedTime.startTime == "00:00:00") ? '' : this.selectedTime.startTime;
                this.selectedTime.endTime = (this.selectedTime.endTime == "00:00:00") ? '' : this.selectedTime.endTime;
            }
        },
        async saveHoliday(closeInd) {
            if(closeInd) {
                if(this.holidayStartTime != null && this.holidayEndTime != null) {
                    let sd = this.holidayStartTime.hours+":"+this.holidayStartTime.minutes+":"+this.holidayStartTime.seconds;
                    let ed = this.holidayEndTime.hours+":"+this.holidayEndTime.minutes+":"+this.holidayEndTime.seconds;
                    this.selectedTime.startTime = sd;
                    this.selectedTime.endTime = ed;
                } 
                let formResponse = {
                    stationId: this.stationId,
                    holidayId: this.selectedHolidayData.holidayId,
                    stationHolidayId: this.selectedHolidayData.stationHolidayId,
                    year: moment(this.selectedDate).format('YYYY'),
                    state: this.state,
                    holidayName: this.holidayName,
                    date: moment(this.selectedDate).format('YYYY/MM/DD'),
                    fulldayHoliday: this.fulldaySelected ? 'Y' : 'N' ,
                    startTime: this.selectedTime.startTime,
                    endTime:  this.selectedTime.endTime,
                    status: this.selectedHolidayData.status != undefined ? this.selectedHolidayData.status : 'A',
                    success: closeInd,
                    formData: closeInd ? this.selectedTime : null,
                    fromWhere: this.holidayType,
                };
                let addHoliday;
                if(this.holidayName === undefined || this.holidayName === '') {
                    new ToastUtils().presentToast("Enter Holiday Name");
                } else if(this.selectedDate === undefined || new Date(this.selectedDate) <= new Date()) {
                    new ToastUtils().presentToast("Select valid date");
                } else {
                    this.loaderTab = true;
                    this.disableButton = true;
                    let checkReservation = await new HolidayService().checkReservationForSelectedDate({
                        "stationId" : this.stationId,
                        "startDateTime": moment(this.selectedDate).format('DD/MM/YYYY'),
                        "startTime": this.selectedTime.startTime,
                        "endTime": this.selectedTime.endTime
                    });
                    if(checkReservation == 'true') {
                        addHoliday = await new HolidayService().addHolidayInStationWorkHoliday(formResponse);
                        await modalController.dismiss(addHoliday);
                        this.loaderTab = false;
                        this.disableButton = false;
                    } else {
                        this.loaderTab = false;
                        this.disableButton = false;
                        new ToastUtils().presentToast("You can't take leave for this day");
                    } 
                }
            } else {
                modalController.dismiss('');
            }

        }
    },
})
</script>

<style scoped>
.modal-wrapper, .ion-overlay-wrapper {
    width:100% !important;
}
  .closeIcon {
    font-size: 1.6rem;
    /* margin-right: 16px; */
  }
  .stop-repeating-content {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  overflow: scroll;
}
</style>